import { c as _c } from "react/compiler-runtime";
import { useChains, useCurrencies } from "@opensea/app-kit";
import { Link } from "@opensea/navigation";
import { Avatar } from "@opensea/next-ui-kit";
import { FlexCenter, NumberDisplay, SkeletonLine, TextBody } from "@opensea/ui-kit";
import { NULL_ADDRESS } from "@opensea/utils";
import { useActiveChain } from "@opensea/wallet";
import { useCurrencyUrl } from "@/components/currencies/use-currency-url";
export function PageFooterNativeCurrencyPrice() {
  const $ = _c(34);
  const activeChain = useActiveChain();
  const {
    getLogo
  } = useChains();
  const {
    getCurrency,
    getUsdPrice
  } = useCurrencies();
  const {
    getCurrencyUrlByContract
  } = useCurrencyUrl();
  let T0;
  let T1;
  let T2;
  let T3;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== activeChain || $[1] !== getCurrency || $[2] !== getCurrencyUrlByContract || $[3] !== getLogo || $[4] !== getUsdPrice) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const currencyIdentifier = activeChain?.nativeCurrency && activeChain.nativeCurrency.symbol !== "ETH" ? {
        contractAddress: activeChain.nativeCurrency.contractAddress,
        chainIdentifier: activeChain.identifier
      } : getCurrency({
        contractAddress: NULL_ADDRESS,
        chainIdentifier: "ethereum"
      });
      if (!currencyIdentifier) {
        let t7;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = <SkeletonLine className="h-5 w-[60px]" />;
          $[16] = t7;
        } else {
          t7 = $[16];
        }
        t6 = t7;
        break bb0;
      }
      T3 = Link;
      t5 = getCurrencyUrlByContract(currencyIdentifier.chainIdentifier, currencyIdentifier.contractAddress);
      T2 = FlexCenter;
      t3 = "gap-1 text-text-secondary";
      t4 = <Avatar {...getLogo(currencyIdentifier.chainIdentifier)} size={12} />;
      T1 = TextBody;
      t2 = "xs";
      T0 = NumberDisplay;
      t0 = "usd";
      t1 = getUsdPrice(currencyIdentifier, 1);
    }
    $[0] = activeChain;
    $[1] = getCurrency;
    $[2] = getCurrencyUrlByContract;
    $[3] = getLogo;
    $[4] = getUsdPrice;
    $[5] = T0;
    $[6] = T1;
    $[7] = T2;
    $[8] = T3;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    T0 = $[5];
    T1 = $[6];
    T2 = $[7];
    T3 = $[8];
    t0 = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[17] !== T0 || $[18] !== t0 || $[19] !== t1) {
    t7 = <T0 display={t0} value={t1} />;
    $[17] = T0;
    $[18] = t0;
    $[19] = t1;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== T1 || $[22] !== t2 || $[23] !== t7) {
    t8 = <T1 size={t2}>{t7}</T1>;
    $[21] = T1;
    $[22] = t2;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== T2 || $[26] !== t3 || $[27] !== t4 || $[28] !== t8) {
    t9 = <T2 className={t3}>{t4}{t8}</T2>;
    $[25] = T2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== T3 || $[31] !== t5 || $[32] !== t9) {
    t10 = <T3 href={t5}>{t9}</T3>;
    $[30] = T3;
    $[31] = t5;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
}